
export const range = function* (start=0, end: number, step=1): Generator<number> {
    if(start > end) return
    yield start
    yield* range(start + step, end, step)
}